import { auth } from '@modules';

export const isRoleSystemAdmin = (): boolean => auth.useRole() === 'ROLE_SUPER_ADMIN';

export const isRoleAdmin = (): boolean => auth.useRole() === 'ROLE_ADMIN';

export const isRoleEditor = (): boolean => auth.useRole() === 'ROLE_EDITOR';
